<ng-container *transloco="let t">
  <div
    class="footer-block__info--title"
    dataAttribute
    componentName="footer-info-title"
    [componentValue]="t(column().title)"
  >
    {{ t(column().title) }}
  </div>
  <div
    class="footer-block__items"
    dataAttribute
    componentName="footer-column"
    [componentValue]="index()"
  >
    @for (menuItem of visibleCategoryItems(); track menuItem) {
      <a
        class="footer-block__item body text--hover text--hover-primary decoration-none"
        [routerLink]="menuItem.route"
        [target]="menuItem.target"
        dataAttribute
        componentName="footer-menu-item"
        [componentValue]="t(menuItem.title)"
      >
        {{ t(menuItem.title) }}
      </a>
    }
  </div>

  @if (visibleColumnFooterLink(); as columnFooterLink) {
    <a
      class="footer-block__info--title body text--hover text--hover-primary decoration-none"
      [routerLink]="columnFooterLink.route"
      [target]="columnFooterLink.target"
      dataAttribute
      componentName="footer-menu-item"
      [componentValue]="t(columnFooterLink.title)"
    >
      {{ t(columnFooterLink.title) }}
    </a>
  }
</ng-container>
